import { useEffect, useRef, useState } from 'react';
import { useTabsNavigation } from '../contexts/TabsNavigationContext';

// Returns a token that increments every time the navigation chrome (Sidebar /
// MobileTabBar) navigates to `tabRouteName` — re-tapping the active item, or
// arriving from another section or a dismissed detail. Consumers append it to
// the `key` of their scroll container so it remounts and lands at the top
// (FLOSEAI-416).
//
// We remount instead of calling scrollToOffset/scrollTo imperatively because on
// RN-web a FlatList's scroll methods target an inner node, not the element that
// actually scrolls, so the imperative reset is silently dropped. A fresh mount
// always starts at offset 0 on web and native alike. Detail screens reached via
// router.push/back never pulse, so this only fires for chrome navigation.
export function useTabNavResetKey(tabRouteName: string): number {
  const tabsNav = useTabsNavigation();
  const navPulse = tabsNav?.navPulse;
  const [resetKey, setResetKey] = useState(0);
  const lastSeqRef = useRef(navPulse?.seq ?? 0);

  useEffect(() => {
    if (!navPulse) return;
    if (navPulse.tab !== tabRouteName) return;
    if (navPulse.seq === lastSeqRef.current) return;
    lastSeqRef.current = navPulse.seq;
    setResetKey((k) => k + 1);
  }, [navPulse, tabRouteName]);

  return resetKey;
}
